import {
  Directive,
  Input,
  TemplateRef,
  ViewContainerRef,
  Renderer2,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';

@Directive({
  selector: '[appToggleArray]',
})
export class ToggleArrayDirective<T> {
  @Input()
  set appToggleArrayOf(array: T[]) {
    this._array = array;
    this.render();
  }
  @Input()
  set appToggleArraySize(size: number) {
    this._displayCount = size;
    this.render();
  }
  @Input()
  set appToggleArrayShowCount(value: boolean) {
    this._showCount = value;
    this.render();
  }

  private _styleClass: string = 'rts-toggle-text';
  private _lessClass: string = 'rts-toggle-text-less';
  private _moreClass: string = 'rts-toggle-text-more';
  private _lessBtnText: string = 'Скрыть';
  private _moreBtnText: string = 'Показать ещё';
  private _array: T[] = [];
  private _displayCount = 3;
  private _isExpanded = false;
  private _buttonContainer: HTMLElement | null = null;
  private _showCount: boolean = true;

  constructor(
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private _renderer: Renderer2,
    private _elementRef: ElementRef,
    private _cdr: ChangeDetectorRef
  ) {}

  private render() {
    this._viewContainer.clear();

    const itemsToDisplay = this._isExpanded
      ? this._array.length
      : Math.min(this._array.length, this._displayCount);

    for (let i = 0; i < itemsToDisplay; i++) {
      this._viewContainer.createEmbeddedView(this._templateRef, {
        $implicit: this._array[i],
        index: i,
      });
    }

    const shouldShowButton = this._array.length > this._displayCount;
    if (shouldShowButton && !this._buttonContainer) {
      this.addToggleButton();
    }

    if (this._buttonContainer) {
      this.updateButtonText();
    }

    if (!shouldShowButton && this._buttonContainer) {
      this.removeToggleButton();
    }

    this._cdr.markForCheck();
  }

  private addToggleButton(): void {
    const parentElement = this._elementRef.nativeElement.parentElement;

    if (!parentElement) {
      console.error('Родительский элемент не найден для директивы appToggleArray');
      return;
    }

    if (!this._buttonContainer) {
      this._buttonContainer = this._renderer.createElement('div');
      this._renderer.appendChild(parentElement, this._buttonContainer);
    }

    this._buttonContainer.innerHTML = '';

    const button = this._renderer.createElement('span');
    const label = this._isExpanded
      ? this._lessBtnText
      : `${this._moreBtnText} ${this._showCount ? this._array.length - this._displayCount : ''}`;
    const toggleClass = this._isExpanded ? this._lessClass : this._moreClass;

    this._renderer.setProperty(button, 'textContent', label);
    this._renderer.addClass(button, this._styleClass);
    this._renderer.addClass(button, toggleClass);

    this._renderer.listen(button, 'click', () => {
      this._isExpanded = !this._isExpanded;
      this.render();
    });

    this._renderer.appendChild(this._buttonContainer, button);
  }

  private updateButtonText(): void {
    const button = this._buttonContainer.querySelector('span');
    if (button) {
      const label = this._isExpanded
        ? this._lessBtnText
        : `${this._moreBtnText} ${this._showCount ? this._array.length - this._displayCount : ''}`;
      const toggleClass = this._isExpanded ? this._lessClass : this._moreClass;

      this._renderer.setProperty(button, 'textContent', label);
      this._renderer.removeClass(button, this._lessClass);
      this._renderer.removeClass(button, this._moreClass);
      this._renderer.addClass(button, toggleClass);
    }
  }

  private removeToggleButton(): void {
    if (this._buttonContainer) {
      const parentElement = this._elementRef.nativeElement.parentElement;
      if (parentElement) {
        this._renderer.removeChild(parentElement, this._buttonContainer);
      }
      this._buttonContainer = null;
    }
  }
}
